// eslint-disable-next-line no-unused-vars
import React, { useState } from 'react';
import styled from '@emotion/styled';
import { ComposedModal, ModalBody, ModalHeader } from '@carbon/react';
import { string } from 'prop-types';

const StyledZoomImage = styled.div`
  box-sizing: border-box;
  width: 100%;

  .zoomImageTrigger {
    background: transparent;
    border: 0;
    cursor: zoom-in;
    display: block;
    padding: 0;
    width: 100%;
  }

  .zoomImageTrigger:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }

  .zoomImage {
    display: block;
    height: auto;
    object-fit: cover;
    width: 100%;
  }
`;

const StyledComposedModal = styled(ComposedModal)`
  .cds--modal-container {
    height: 90vh;
    max-height: 90vh;
    max-width: 90vw;
    width: 90vw;
  }

  .cds--modal-header {
    min-height: 3rem;
  }

  .cds--modal-content {
    height: calc(100% - 3rem);
    overflow: auto;
    padding: 0;
  }

  .zoomImageTitle {
    font-size: 0.875rem;
    font-weight: 600;
    margin: 0;
  }

  .zoomImageStage {
    align-items: center;
    display: flex;
    height: max-content;
    justify-content: center;
    min-height: 100%;
    min-width: 100%;
    width: max-content;
  }

  .zoomImageOriginal {
    display: block;
    height: auto;
    max-height: none;
    max-width: none;
    width: auto;
  }

  @media screen and (max-width: 720px) {
    .cds--modal-container {
      max-width: 96vw;
      width: 96vw;
    }
  }
`;

const ZoomImageComponent = ({ uploadedImageUrl, imageUrl, imageAlt }) => {
  const [open, setOpen] = useState(false);
  const resolvedImageUrl = uploadedImageUrl || imageUrl;

  if (!resolvedImageUrl) return null;

  return (
    <>
      <StyledZoomImage>
        <button
          className="zoomImageTrigger"
          type="button"
          aria-label={ imageAlt
            ? `View ${imageAlt} at original size`
            : 'View image at original size' }
          onClick={ () => setOpen(true) }
        >
          <img className="zoomImage" src={ resolvedImageUrl } alt={ imageAlt } />
        </button>
      </StyledZoomImage>
      <StyledComposedModal
        className="ZoomImageModal"
        open={ open }
        size="lg"
        selectorPrimaryFocus=".cds--modal-close"
        onClose={ () => setOpen(false) }
      >
        <ModalHeader>
          <h2 className="zoomImageTitle">{imageAlt || 'Image preview'}</h2>
        </ModalHeader>
        <ModalBody>
          <div className="zoomImageStage">
            <img
              className="zoomImageOriginal"
              src={ resolvedImageUrl }
              alt={ imageAlt }
            />
          </div>
        </ModalBody>
      </StyledComposedModal>
    </>
  );
};

ZoomImageComponent.propTypes = {
  uploadedImageUrl: string,
  imageUrl: string,
  imageAlt: string,
};

const ZoomImage = {
  label: 'Zoom Image',
  fields: {
    uploadedImageUrl: { type: 'text', label: 'Uploaded image URL' },
    imageUrl: { type: 'text', label: 'Image URL (fallback)' },
    imageAlt: { type: 'text', label: 'Image Alt' },
  },
  defaultProps: {
    uploadedImageUrl: '',
    imageUrl: 'https://picsum.photos/1200/800',
    imageAlt: '',
  },
  // eslint-disable-next-line react/jsx-props-no-spreading
  render: props => <ZoomImageComponent { ...props } />,
};

// eslint-disable-next-line import/prefer-default-export
export { ZoomImage };
